var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "url(#paint0_linear_28_523)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5V15.7917C5 17.5621 6.43792 19 8.20833 19H15.7917C17.5621 19 19 17.5621 19 15.7917V5H5ZM18.4167 15.7917C18.4167 17.2383 17.2383 18.4167 15.7917 18.4167H8.20833C6.76167 18.4167 5.58333 17.2383 5.58333 15.7917V5.58333H18.4167V15.7917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 7.33333H7.91663V7.91666H16.0833V7.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7258 14.9225L9.29039 12.4871L8.87622 12.8983L11.8483 15.8704L15.1704 10.1246L14.6629 9.83292L11.7258 14.9225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_523",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.3502efda560512ec9d943cb777b9675e.svg";
export { ForwardRef as ReactComponent };